<template>
    <div>
        <div  v-if="backpack.length > 0 && cPack == 'pack'" class="list">
            <goods-item v-for="(row, i) in backpack" :row="row" :key="i" />
        </div>
       
        <div class="text" v-else-if="backpack.length == 0 && cPack == 'pack' && !loading">
            <p>(您当前没有可交易物品,先去市场逛逛吧)</p>
        </div>
    </div>
</template>
<script>
import { debounce } from 'riku-verycloud'
export default {
    name: 'goods',
    props: ['params','cPack'],
    computed: {
        trigger() {
            return this.$QueryString.stringify(this.params);
        }
    },
    data() {
        return {
            loading: true,
            backpack: [],
        }
    },
    methods: {
        getbackpack: debounce(function() {
                this.$Ajax('goods/backpack',this.params,'get').then(rs => {
                    this.loading = false
                    if(rs.code == 200) {
                        this.backpack = rs.data
                    }else {
                        this.backpack = []
                    }
                })
        }),
    },
    watch: {
        trigger(e) {
            this.getbackpack()
        }
    }
}
</script>
<style lang="less" socped>
    // .list {
    //     display: flex;
    //     flex-wrap: wrap;
    // }
    // .text {
    //     text-align: center;
    //     color: rgb(107, 107, 107);
    // }
</style>